<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Közösségi szolgálat</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="csi-lap">
    <p class="csi-lead">
      Az érettségi bizonyítvány kiadásához <b>50 óra</b> közösségi szolgálatot kell teljesíteni, általában
      a 9–11. évfolyamon. Itt látszik, mennyi van meg eddig. Kérdés esetén
      {{ tanuloNezet ? 'az osztályfőnöködhöz' : 'az osztályfőnökhöz' }} vagy az iskola közösségi
      szolgálat-koordinátorához lehet fordulni.
    </p>

    <div class="csi-allapot" *ngIf="toltodik">
      <ion-spinner name="dots"></ion-spinner><span>Betöltés…</span>
    </div>
    <div class="csi-allapot hiba" *ngIf="!toltodik && hiba">
      <ion-icon name="alert-circle-outline"></ion-icon><span>{{ hiba }}</span>
    </div>
    <div class="csi-ures" *ngIf="!toltodik && !hiba && !kartyak.length">
      Nincs a fiókhoz rendelt tanuló.
    </div>

    <ion-card *ngFor="let k of kartyak" class="csi-kartya">
      <ion-card-header>
        <ion-card-title>{{ k.nev }}</ion-card-title>
        <ion-card-subtitle *ngIf="k.osztaly">{{ k.osztaly }}</ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <div class="csi-allapot" *ngIf="k.toltodik">
          <ion-spinner name="dots"></ion-spinner><span>Betöltés…</span>
        </div>
        <div class="csi-allapot hiba" *ngIf="!k.toltodik && k.hiba">
          <ion-icon name="alert-circle-outline"></ion-icon><span>{{ k.hiba }}</span>
        </div>

        <ng-container *ngIf="!k.toltodik && !k.hiba">
          <div class="csi-ures" *ngIf="meg_nem_kezdodott(k)">
            A közösségi szolgálat a 9. évfolyamtól kezdődik – még nincs rögzített tevékenység.
          </div>

          <ng-container *ngIf="!meg_nem_kezdodott(k)">
            <div class="csi-haladas" [class.kesz]="k.teljesitve">
              <div class="csi-szam">
                <span class="ertek">{{ ora(k.ora) }}</span>
                <span class="cel">/ {{ k.cel }} óra</span>
              </div>
              <div class="csi-sav" role="progressbar" [attr.aria-valuenow]="k.ora" aria-valuemin="0"
                   [attr.aria-valuemax]="k.cel" [attr.aria-label]="'Közösségi szolgálat: ' + ora(k.ora) + ' óra a ' + k.cel + '-ből'">
                <div class="csi-kitoltes" [style.width.%]="szazalek(k)"></div>
              </div>
              <div class="csi-uzenet">
                <ng-container *ngIf="k.teljesitve">
                  <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
                  Teljesítve – megvan az érettségihez szükséges óraszám.
                </ng-container>
                <ng-container *ngIf="!k.teljesitve">Még <b>{{ ora(k.hianyzik) }} óra</b> hiányzik.</ng-container>
              </div>
            </div>

            <div class="csi-ures" *ngIf="!k.tetelek.length">Még nincs rögzített tevékenység.</div>

            <ul class="csi-tetelek" *ngIf="k.tetelek.length">
              <li *ngFor="let x of k.tetelek">
                <div class="csi-tetel-fej">
                  <span class="csi-datum">{{ idoszak(x) }}</span>
                  <span class="csi-ora">{{ ora(x.oraszam) }} óra</span>
                </div>
                <div class="csi-tipus">{{ x.tipus }}</div>
                <div class="csi-hely" *ngIf="x.teljesitesi_hely">{{ x.teljesitesi_hely }}</div>
                <div class="csi-megj" *ngIf="x.megjegyzes">{{ x.megjegyzes }}</div>
              </li>
            </ul>
          </ng-container>
        </ng-container>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
